import React, { useState } from 'react';
import { format, addDays } from 'date-fns';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const WeekSelector = ({ onWeekChange }) => {
  const [currentDate, setCurrentDate] = useState(new Date());

  // Calcul des dates de début et de fin de la semaine
  const getWeekDates = (date) => {
    const start = new Date(date); // Jour actuel
    const end = addDays(start, 7); // Jour actuel + 7 jours (une semaine plus tard)
    return { start, end };
  };

  const { start, end } = getWeekDates(currentDate);

  const handlePrevWeek = () => {
    const newDate = new Date(currentDate);
    newDate.setDate(currentDate.getDate() - 7);
    setCurrentDate(newDate);
    const { start, end } = getWeekDates(newDate);
    onWeekChange({ start_date: format(start, 'yyyy-MM-dd'), end_date: format(end, 'yyyy-MM-dd') });
  };

  const handleNextWeek = () => {
    const newDate = new Date(currentDate);
    newDate.setDate(currentDate.getDate() + 7);
    setCurrentDate(newDate);
    const { start, end } = getWeekDates(newDate);
    onWeekChange({ start_date: format(start, 'yyyy-MM-dd'), end_date: format(end, 'yyyy-MM-dd') });
  };

  return (
    <div className="w-full flex justify-center">
      <div className="flex items-center justify-center gap-4 mb-4">
        <button
          onClick={handlePrevWeek}
          className="p-1 mx-2 border rounded hover:bg-gray-100"
          type="button"
        >
          <ChevronLeft className="w-4 h-4" />
        </button>
        <span className="text-sm font-medium">
          {format(start, 'd MMMM yyyy')} - {format(end, 'd MMMM yyyy')}
        </span>
        <button
          onClick={handleNextWeek}
          className="p-1 mx-2 border rounded hover:bg-gray-100"
          type="button"
        >
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default WeekSelector;
